// ----------------- React Native ---------------
import { SectionList } from "react-native";

import Box from "@memorang/ui/src/components/Box";
import { CustomListSubheader } from "@memorang/ui/src/components/CustomListSubheader";
import MoreSettingsListItem from "@memorang/ui/src/components/MoreApplet/MoreSettingsListItem";
import type {
	MoreSettingsItem,
	MoreSettingsSection,
} from "@memorang/ui/src/components/MoreApplet/types";
import { useDevice } from "@memorang/ui/src/useDevice";
import { Card } from "react-native-paper";
import type { FontSchemaType } from "../../types";
import CustomNavigationBar from "../CustomAppbar";
import type { CustomNavigationBarProps } from "../CustomAppbar/types";
import ScrollContainer from "../ScrollContainer";
interface Props {
	sections: MoreSettingsSection[];
	handleClickMoreSettingsItem: (type: MoreSettingsItem) => void;
	appFont: FontSchemaType;
	CustomAppBar: CustomNavigationBarProps;
}

const MoreApplet = ({
	sections,
	handleClickMoreSettingsItem,
	appFont,
	CustomAppBar,
}: Props) => {
	const { isMobile } = useDevice();
	const Wrapper = isMobile ? Box : Card;
	return (
		<Box position="relative" flexGrow={1} height={"100%"}>
			<CustomNavigationBar
				mode={isMobile ? "small" : "medium"}
				align={CustomAppBar.align ?? "flex-start"}
				showCommandBar={CustomAppBar.showCommandBar}
				showSettings={CustomAppBar.showSettings}
				showUserMenu={CustomAppBar.showUserMenu}
				renderSearchbar={CustomAppBar.renderSearchbar}
				options={{
					headerTitle: CustomAppBar.options?.headerTitle,
					subtitle: CustomAppBar.options?.subtitle,
					headerRight: CustomAppBar.options?.headerRight,
					headerLeft: CustomAppBar.options?.headerLeft,
				}}
				handleFeedbackNavigation={CustomAppBar.handleFeedbackNavigation}
				onAvatarPress={CustomAppBar.onAvatarPress}
				onBackPress={CustomAppBar.onBackPress}
				toggleShowFeedbackDialog={CustomAppBar.toggleShowFeedbackDialog}
				onHamburgerMenuPress={CustomAppBar.onHamburgerMenuPress}
				userInfo={CustomAppBar.userInfo}
				trackCustomEvent={CustomAppBar.trackCustomEvent}
				toggleCommandbar={CustomAppBar.toggleCommandbar}
				handleTrackEvent={CustomAppBar.handleTrackEvent}
				back={CustomAppBar.back}
				stats={CustomAppBar.stats}
				breadcrumbs={CustomAppBar.breadcrumbs}
				showHambugerMenu={CustomAppBar.showHambugerMenu}
				accessible
				accessibilityLabel={CustomAppBar.accessibilityLabel}
			/>
			<ScrollContainer
				style={{
					padding: isMobile ? 0 : 16,
				}}
				// biome-ignore lint/a11y/useSemanticElements: <explanation>
				role="main"
			>
				<Wrapper>
					<SectionList
						sections={sections}
						scrollEnabled={false}
						contentContainerStyle={{
							paddingTop: 16,
						}}
						renderSectionHeader={({ section: { sectionTitle } }) => {
							return (
								<CustomListSubheader font={appFont}>
									{sectionTitle}
								</CustomListSubheader>
							);
						}}
						renderItem={({ item }) => {
							return (
								<MoreSettingsListItem
									item={item}
									handleClick={handleClickMoreSettingsItem}
								/>
							);
						}}
					/>
				</Wrapper>
			</ScrollContainer>
		</Box>
	);
};

export default MoreApplet;
